// extracted by mini-css-extract-plugin
module.exports = {"container":"DotLoader_container__359O8","dot":"DotLoader_dot__3eAtq","fade":"DotLoader_fade__2UWKx"};